import React from "react";

const DashboardTabsSkeleton = () => (
  <div className="dashboardV2TabRow">
    <div className="dashboardV2Tabs">
      {Array.from({ length: 3 }).map((_, i) => (
        <span key={i} className="linear-background dashboardV2TabSkeleton" />
      ))}
    </div>
  </div>
);

export default DashboardTabsSkeleton;
